import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {
  ShowUploadModalProps,
  UploadModalState,
} from '../../interfaces/connected-components/uploadModal';

const initialState: UploadModalState = {
  isVisible: false,
};

export const uploadModalSlice = createSlice({
  name: 'uploadModal',
  initialState,
  reducers: {
    showUploadModal: (state, action: PayloadAction<ShowUploadModalProps>) => {
      state.isVisible = true;
      state.onSelectionChange = action.payload.onSelectionChange;
      state.options = action.payload.options;
    },
    hideUploadModal: state => {
      state.isVisible = false;
      state.onSelectionChange = undefined;
    },
  },
});

// Action creators are generated for each case reducer function
export const {showUploadModal, hideUploadModal} = uploadModalSlice.actions;

export default uploadModalSlice.reducer;
